import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useNavigate, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";
  
  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const exportCutterData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const headers = [
  { label: "CUTTER CODE", key: "cutter_code" },
  { label: "CUTTER NAME", key: "cutter_name" },
  { label: "MIN. GSM", key: "minimum_gsm" },
  { label: "MAX. GSM", key: "maximum_gsm" },
  { label: "MIN. DECKLE LENGTH", key: "minimum_width" },
  { label: "MAX. DECKLE LENGTH", key: "maximum_width" },
  { label: "LEFT EDGE TRIM", key: "left_edge_trim" },
  { label: "RIGHT EDGE TRIM", key: "right_edge_trim" },
  { label: "EFFECTIVE. DECKLE LENGTH", key: "effective_deckle_length" },
  { label: "MAX. ALLOWED LOSS", key: "maximum_loss" },
  { label: "TYPE", key: "type" },
  { label: "MAX. DIFFERENCE IN CHOP SIZE", key: "diff_chop_size" },
  { label: "MIN. REEL DIA", key: "min_reel_dia" },
  { label: "MAX. REEL DIA", key: "max_reel_dia" },
  { label: "CUTTER CAPACITY", key: "capacity" },
  { label: "LOADING STANDS", key: "loading_stands" },
  { label: "CREATED DATE", key: "createdDate" },
  { label: "STATUS", key: "status" },
];

const ExportCutter = (props) => {
    const [exportCutterDetail, setexportCutterDetail] = useState(
        exportCutterData[1].value
      );
      const location = useLocation();
      const [parentRecords, setParentRecords] = useState(location.state?.cutterRecords);
      const [cutterRecords, setcutterRecords] = useState([]);
      const [fileName, setFileName] = useState(location.state?.fileName?  location.state?.fileName : "Cutter_Records")
      const history = useNavigate();

      useEffect(() => {
        if(!location?.state?.onBack){
            fetchCutterRecords();
        } else{
            setcutterRecords(parentRecords);
        }
      }, [parentRecords]);

      useEffect(()=> {
        if(cutterRecords?.length){
          if (!location?.state?.onBack) {
            if(exportCutterData === "PDF"){
              history("../cutter-records/export-cutter/pdf", {
                    state: {
                        body: location?.state?.body,
                        cutterRecords: cutterRecords,
                        rootPage: location?.state?.rootPage,
                        fileNameForPDF: fileName,
                        exportCutterDetail: exportCutterDetail
                      },
              });
            }
            else
            {
              exportHandler();
            }
          }
      }
      },[cutterRecords]);

      const fetchCutterRecords = async () => {
        try {
            const formattedRecords = parentRecords?.map((cutter) => {
            return {
                cutter_code: cutter.code,
                cutter_name: cutter.name,
                minimum_gsm: cutter.minimum_gsm,
                maximum_gsm: cutter.maximum_gsm,
                minimum_width: cutter.minimum_width + ' ' + lengthUnit[cutter.units.minimum_width].displayName,
                maximum_width: cutter.maximum_width + ' ' +lengthUnit[cutter.units.maximum_width].displayName,
                width_range: `${cutter.minimum_width} - ${cutter.maximum_width} ${lengthUnit[cutter.units.maximum_width].displayName}`,
                left_edge_trim: cutter.left_edge_trim + " " + lengthUnit[cutter.units.left_edge_trim].displayName,
                right_edge_trim: cutter.right_edge_trim + " " + lengthUnit[cutter.units.right_edge_trim].displayName,
                effective_deckle_length: cutter.effective_deckle_length + " " + lengthUnit[cutter.units.effective_deckle_length].displayName,
                maximum_loss: cutter.maximum_loss,
                type: cutter.type,
                diff_chop_size: cutter.maximum_difference_chop_size + ' ' + (cutter.type == 'duplex' && cutter.units.maximum_difference_chop_size ?  cutter.units.maximum_difference_chop_size:''),
                reel_dia_range: `${cutter.minimum_reel_dia} - ${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
                min_reel_dia: `${cutter.minimum_reel_dia} ${lengthUnit[cutter.units.minimum_reel_dia].displayName.toUpperCase()}`,
                max_reel_dia: `${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
                loading_stands: cutter.loading_stands,
                capacity: cutter.capacity + " " + capitalize(weightUnit[cutter.units.capacity].displayName) + ' / day',
                createdDate: moment(cutter.created_at).format("DD MMM YYYY"),
                status: cutter.status === "active" ? "Active" : "Disabled",
                gsm_range: `${cutter.minimum_gsm} - ${cutter.maximum_gsm}`,
                units : cutter.units
            };
          });
          setcutterRecords(formattedRecords);
          setexportCutterDetail(location?.state?.exportCutterDetail);
        } catch (err) {
            console.log("Error in fetching cutter records", err);
          }
      };

      const exportStatusChange = (e) => {
        setexportCutterDetail(e.target.value);
      };

      const exportHandler = async() => {
        if(cutterRecords?.length){
          if(exportCutterDetail === "CSV"){
            try{
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('Cutter Records');
    
              worksheet.columns = headers.map((header)=>({
                header: header.label,
                key: header.key,
              }))
    
              const headRow = worksheet.getRow(1);
    
              headRow.eachCell((cell)=>{
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: {
                    argb: "f3f4f6"
                  }
                }
                cell.font = {
                  bold: true,
                }
              })
    
              cutterRecords?.forEach((record)=>{
                const row = worksheet.addRow(record);
              })
    
              worksheet.columns.forEach((column)=>{
                let maxLength = 10;
                column.eachCell((cell)=>{
                  let value = cell?.value?.toString() || "";
                  maxLength = Math.max(maxLength,value?.length);
                })
                column.width = maxLength>50?50:maxLength+2;
              })
    
              const buffer = await workbook.xlsx.writeBuffer();
              saveAs(new Blob([buffer]),`${fileName}.xlsx`)
            }
            catch(e)
            {
              console.log(e);
            }
          } else {
            history("../cutter-records/export-cutter/pdf", {
                    state: {
                        body: location?.state?.body,
                        cutterRecords: cutterRecords,
                        rootPage: location?.state?.rootPage,
                        fileNameForPDF: fileName,
                        exportCutterDetail: exportCutterDetail
                      },
              });
          }
        } else{
          history("../cutter-records/preparing-export-cutter", {
            state: {
              body: location?.state?.body,
              rootPage: location?.state?.rootPage,
              fileName: fileName,
              headers: headers,
              exportCutterDetail: exportCutterDetail
            },
          });
        }
      };

      return (
        <RightLayoutContainer>
            <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../cutter-records")}
          title="Export cutter records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../cutter-records")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportCutterData}
                          onChange={exportStatusChange}
                          value={exportCutterDetail? exportCutterDetail : "PDF"}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                  {!exportCutterDetail || exportCutterDetail === "PDF" ? (
                    <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview &#38; Download Records
                    </Button>
                  ) : (
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Cutter Records
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
        </RightLayoutContainer>
      );
};
export default ExportCutter;